import { colors } from '../../../themes/stena-recycling/colors';
import { Tooltip, TooltipContent, TooltipTrigger, type TooltipOptions } from '.';

type SimpleTooltipProps = {
  children: React.ReactNode;
} & Omit<TooltipOptions, 'children'>;

export const SimpleTooltip = ({ children, ...props }: SimpleTooltipProps) => {
  return (
    <Tooltip {...props}>
      <TooltipTrigger color={colors.primary.blue} />

      <TooltipContent>{children}</TooltipContent>
    </Tooltip>
  );
};
